import { api, apiFile, base_url_v1, base_url_v2 } from "./api";

export const ModuleApi = async () => {
    const data = await api({ url: `${base_url_v2}company/modules`, method: "GET", token: true })
    return data;
}



export const BuyModuleApi = async (id:number ) => {
    let postData = JSON.stringify({
        'module_id': id,
        'return_page':'https://panel.dayan.app/p/module-result',
    })
    const data = await api({ url: `${base_url_v2}company/pay-for-module`, method: "POST", token: true, body: postData })
    return data;
}

